module.exports = __webpack_public_path__ + "media/images/premierad-cabe462966715b48051f1182c3517801.png";